export const environment = {
  dev: {
    baseUrl: "https://4fbk17w8q8.execute-api.eu-central-1.amazonaws.com/v1",
  },
  prod: {
    baseUrl: "https://4fbk17w8q8.execute-api.eu-central-1.amazonaws.com/v1",
  },
};
